import ImageOptimizer from '@/components/image-optimizer';
import React from 'react';

interface Props {
  imageSrc: string;
  imageAlt: string;
  subtitle: string;
  title: string;
  description: string;
}

const FeatureCard = ({
  imageSrc,
  imageAlt,
  subtitle,
  title,
  description,
}: Props) => {
  return (
    <div className="desktop:rounded-[20px] desktop:shadow-xl h-full w-full overflow-hidden rounded-2xl shadow-md">
      <div className="relative aspect-[572/332] h-auto w-full">
        <ImageOptimizer src={imageSrc} alt={imageAlt} fill />
      </div>
      <div className="desktop:text-start desktop:pt-10 desktop:pb-14 desktop:px-11 bg-white px-4 py-8 text-center">
        <h3 className="typo-24 text-level-2 desktop:typo-32 desktop:leading-none desktop:pb-4.5 leading-normal font-bold">
          {subtitle}
        </h3>
        <h2 className="typo-26 text-level-2 desktop:typo-36 desktop:leading-none desktop:pb-8 pb-5 leading-normal font-black">
          {title}
        </h2>

        {/**웹 */}
        <p className="typo-22 text-level-3 desktop:block hidden leading-relaxed font-semibold">
          {description.split('\n').map((line, i) => (
            <React.Fragment key={i}>
              {line}
              {i + 1 !== description.split('\n').length && <br />}
            </React.Fragment>
          ))}
        </p>
        {/**모바일 */}
        <p className="typo-18 text-level-3 desktop:hidden leading-normal font-semibold">
          {description.replace(/\n/g, ' ')}
        </p>
      </div>
    </div>
  );
};

export default FeatureCard;
